import { render, staticRenderFns } from "./LegalDocument.vue?vue&type=template&id=5582b529&scoped=true"
import script from "./LegalDocument.vue?vue&type=script&lang=js"
export * from "./LegalDocument.vue?vue&type=script&lang=js"
import style0 from "./LegalDocument.vue?vue&type=style&index=0&id=5582b529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5582b529",
  null
  
)

export default component.exports